import { useExpirationTimer } from './useExpirationTimer';
import { reloadWithParam } from '../utils/window-location/reloadWithParam';
import WINDOW_LOCATION from '../constants/windowLocation';

export const useOutOfStockRedirectionTimer = () => {
    return useExpirationTimer(() => {
        // Redirect back to basket if allocation expires during express checkout
        reloadWithParam(WINDOW_LOCATION.SHOW_OUT_OF_STOCK, String(true));
    });
};
